(function () {
  class YouMayLikeSection extends HTMLElement {
    constructor() {
      super();
      this.cart = {};
    }

    connectedCallback() {
      this.fetchCart();
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener('click', (e) => {
        const addBtn = e.target.closest('.js-you-may-like-add');
        const plusBtn = e.target.closest('.js-qty-plus');
        const minusBtn = e.target.closest('.js-qty-minus');

        if (addBtn) this.addToCart(addBtn);
        if (plusBtn) this.changeQty(plusBtn.closest('.you-may-like__qty'), 1);
        if (minusBtn) this.changeQty(minusBtn.closest('.you-may-like__qty'), -1);
      });

      this.addEventListener('change', (e) => {
        const select = e.target.closest('.you-may-like__variant-select');
        if (!select) return;

        const card = select.closest('.you-may-like__card');
        if (!card) return;

        const selectedVariantId = select.value;
        const addBtn = card.querySelector('.js-you-may-like-add');
        const qtyBox = card.querySelector('.you-may-like__qty');

        if (addBtn) addBtn.dataset.variantId = selectedVariantId;
        if (qtyBox) qtyBox.dataset.variantId = selectedVariantId;

        this.updateSingleCard(card, selectedVariantId);
      });
    }

    updateSingleCard(card, variantId) {
      const btn = card.querySelector('.js-you-may-like-add');
      const qtyBox = card.querySelector('.you-may-like__qty');
      const count = card.querySelector('.you-may-like__qty-count');
      if (!btn || !qtyBox || !count) return;

      const qty = this.cart[variantId] || 0;
      count.textContent = qty;

      if (qty > 0) {
        btn.classList.add('is-hidden');
        qtyBox.classList.add('is-active');
      } else {
        btn.classList.remove('is-hidden');
        qtyBox.classList.remove('is-active');
      }
    }

    async fetchCart() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.cart = {};
        cart.items.forEach(item => {
          this.cart[String(item.variant_id)] = item.quantity;
        });
        this.updateUI();
      } catch (err) {
        console.error('Failed to fetch cart:', err);
      }
    }

    updateUI() {
      this.querySelectorAll('.you-may-like__cart-wrap').forEach((wrap) => {
        const btn = wrap.querySelector('.js-you-may-like-add');
        const qtyBox = wrap.querySelector('.you-may-like__qty');
        const count = wrap.querySelector('.you-may-like__qty-count');
        if (!btn || !qtyBox || !count) return;

        const variantId = qtyBox.dataset.variantId || btn.dataset.variantId;
        const qty = this.cart[variantId] || 0;

        count.textContent = qty;

        if (qty > 0) {
          btn.classList.add('is-hidden');
          qtyBox.classList.add('is-active');
        } else {
          btn.classList.remove('is-hidden');
          qtyBox.classList.remove('is-active');
        }
      });
    }

    // ==================== MAIN FIX: INSTANT CART COUNT UPDATE ====================
    async updateHeaderCartCount(cart) {
      const itemCount = cart.item_count || 0;

      // Update all common cart count elements
      document.querySelectorAll('.cart-count, .header__cart-count, .cart-count-bubble, .site-header__cart-count').forEach(el => {
        if (el) {
          el.textContent = itemCount;
          // Optional: show bubble if > 0
          if (el.classList.contains('cart-count-bubble')) {
            el.style.display = itemCount > 0 ? 'block' : 'none';
          }
        }
      });

      // Trigger standard Shopify theme events
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart },
        bubbles: true 
      }));

      document.dispatchEvent(new CustomEvent('cart:change', { 
        detail: { cart },
        bubbles: true 
      }));
    }

    async addToCart(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        this.cart[String(variantId)] = (this.cart[String(variantId)] || 0) + 1;

        this.updateUI();
        await this.updateHeaderCartCount(cart);

      } catch (err) {
        console.error('Add to cart failed:', err);
        btn.textContent = 'Try Again';
      }

      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = originalText || 'Add to Cart';
      }, 800);
    }

    async changeQty(qtyBox, change) {
      if (!qtyBox) return;
      const variantId = qtyBox.dataset.variantId;
      if (!variantId) return;

      let currentQty = this.cart[variantId] || 0;
      let nextQty = Math.max(0, currentQty + change);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: nextQty })
        });

        this.cart[variantId] = nextQty;
        this.updateUI();

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        await this.updateHeaderCartCount(cart);

      } catch (err) {
        console.error('Quantity change failed:', err);
      }
    }
  }

  if (!customElements.get('you-may-like-section')) {
    customElements.define('you-may-like-section', YouMayLikeSection);
  }
})();
